export default __webpack_public_path__ + "static/media/outcess4.06a3ed9c.jpeg";